<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="15.612"
    viewBox="0 0 21 15.612"
  >
    <path
      d="M20.385,117.847h-.458l-.479-.837,0,0c-.371-.637-.967-1.669-1.308-2.264a1.4,1.4,0,0,0-1.187-.772h0a1.4,1.4,0,0,0-1.185.773l0,.007-.026.046-3.435-5.95a1.7,1.7,0,0,0-1.436-.955h0a1.707,1.707,0,0,0-1.439.955l-1.841,3.189-.2-.345a1.7,1.7,0,0,0-1.436-.955h0a1.705,1.705,0,0,0-1.438.955L.954,117.847H.615a.615.615,0,0,0,0,1.231h19.77a.615.615,0,0,0,0-1.231ZM5.573,112.3c.145-.251.292-.34.373-.34h0c.081,0,.227.089.371.339.024.041.583,1.01.716,1.237a.64.64,0,0,0,.55.315h0a.64.64,0,0,0,.55-.319c.419-.724,2.353-4.077,2.353-4.077.146-.251.293-.34.374-.34h0c.081,0,.227.089.372.339l3.95,6.842a.639.639,0,0,0,.552.319h0a.639.639,0,0,0,.552-.319l.141-.244c.147-.255.286-.5.4-.7a.489.489,0,0,1,.121-.149.481.481,0,0,1,.121.149c.34.592.937,1.626,1.309,2.265l.128.224H2.374Zm0,0"
      transform="translate(0 -103.465)"
      fill="#777"
    />
    <path
      d="M66.348,4.993a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,66.348,4.993Zm0-3.763A1.266,1.266,0,1,1,65.082,2.5,1.268,1.268,0,0,1,66.348,1.23Zm0,0"
      transform="translate(-61.233)"
      fill="#777"
    />
  </svg>
</template>
